import React from 'react';
import { Center } from './center';

import style from './detail-row.module.scss';
import { Side } from './side';

const DetailRow = ({ left = {}, right = {}, center = <></> }) => {
  return (
    <div className={style.detailRow}>
      <Side top={left.top} bottom={left.bottom}></Side>
      <Center content={center} />
      <Side top={right.top} bottom={right.bottom}></Side>
    </div>
  );
};

export { DetailRow };
